<template>
  <div class="header-tops">
    <div class="header-top">
      <div class="navigation-branding">
        <div class="navigation-title" itemprop="headline">
          <a href="/" title="GBWhatsApp" rel="home">
            <img class="header-image is-logo-image" alt="GBWhatsApp" src="../assets/logo.png" title="GBWhatsApp">
          </a>
          <a href="/" class="link-gb" rel="home">
            GB WhatsApp
          </a>
        </div>

        <!-- 汉堡按钮 -->
        <div class="hamburger" @click="toggleMobileMenu">
          <span :class="{ open: isMobileMenuOpen }"></span>
          <span :class="{ open: isMobileMenuOpen }"></span>
          <span :class="{ open: isMobileMenuOpen }"></span>
        </div>
      </div>

        <!-- 移动菜单 -->
         <div v-if="isMobileMenuOpen" class="mobile-menu">
           <div class="mobile-menu-item" @click="goLink('/gb-whatsapp-features/')">Features</div>
           <div class="mobile-menu-item" @click="goLink('/whatsapp-mods/')">WhatsApp Mods</div>
           <div class="mobile-menu-item sub-item" @click="goLink('/fm-whatsapp-download/')">FM WhatsApp</div>
           <div class="mobile-menu-item sub-item" @click="goLink('/yo-whatsapp-download/')">YO WhatsApp</div>
           <div class="mobile-menu-item sub-item" @click="goLink('/whatsapp-plus-download/')">WhatsApp Plus</div>
           <div class="mobile-menu-item" @click="goLink('/news/')">News</div>
         </div>

      <div class="header-right-section">
        <!-- PC 菜单 -->
        <div class="header-menu desktop-menu" v-if="!isMobile">
          <div class="header-menu-item" @click="goLink('/gb-whatsapp-features/')">Features</div>
          <div class="header-menu-item" @click="goLink('/whatsapp-mods/')" @mouseover="showModsDropdown" @mouseleave="hideModsDropdown">
            <span>WhatsApp Mods</span>
            <svg viewBox="0 0 330 512" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em"
              data-v-001400ba="">
              <path
                d="M305.913 197.085c0 2.266-1.133 4.815-2.833 6.514L171.087 335.593c-1.7 1.7-4.249 2.832-6.515 2.832s-4.815-1.133-6.515-2.832L26.064 203.599c-1.7-1.7-2.832-4.248-2.832-6.514s1.132-4.816 2.832-6.515l14.162-14.163c1.7-1.699 3.966-2.832 6.515-2.832 2.266 0 4.815 1.133 6.515 2.832l111.316 111.317 111.316-111.317c1.7-1.699 4.249-2.832 6.515-2.832s4.815 1.133 6.515 2.832l14.162 14.163c1.7 1.7 2.833 4.249 2.833 6.515z"
                data-v-001400ba=""></path>
            </svg>
            <ul v-if="isModsDropdownOpen" class="dropdown-container">
              <li class="dropdown-item" @click.stop="goLink('/fm-whatsapp-download/')">FM WhatsApp</li>
              <li class="dropdown-item" @click.stop="goLink('/yo-whatsapp-download/')">YO WhatsApp</li>
              <li class="dropdown-item" @click.stop="goLink('/whatsapp-plus-download/')">WhatsApp Plus</li>
            </ul>
          </div>
          <div class="header-menu-item news-item" @click="goLink('/news/')">News</div>
        </div>

        <div>
        <a class="downloadBtn" @mouseover="showList" @click.stop="goLink('/download-devices/')"
          @mouseleave="hideList">Download
          <span class="arrow" @click.stop="mobileHide">{{ !isShallow ? '▲' : '▼' }}</span>
        </a>
        <ul class="ul-pc" v-show="isShallow" @mouseover="showList" @mouseleave="hideList">
          <li @click="goLink('/download/gb-whatsapp-pc/')">
            For PC
          </li>
          <li @click="goLink('/download/gb-whatsapp-android/')">
            For Android
          </li>
          <li @click="goLink('/download/gb-whatsapp-web/')">For Web</li>
        </ul>
      </div>
      </div>
    </div>
    <div v-if="breadcrumbs.length" class="breadcrumb-bar">
      <div class="breadcrumb-bar-inner">
        <BreadCrumb :breadcrumbs="breadcrumbs" />
      </div>
    </div>
  </div>
</template>

<script>
import { isMobileDevice } from '@/utlis/global.js';
import BreadCrumb from '@/components/BreadCrumb.vue';
export default {
  components: {
    BreadCrumb,
  },
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  data() {
    return {
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isSearchClicked: false,
      apk: null,
      selectValue: null,
      isMobileMenuOpen: false,
      isMobile: false,
      isShallow: false,
      isModsDropdownOpen: false,
    };
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    },
  },
  computed: {
    breadcrumbs() {
      return this.$route.matched.reduce((acc, route) => {
        const crumbs = route.meta.breadcrumb || [];
        return acc.concat(crumbs);
      }, []);
    },
  },
  mounted() {
    this.getOfficalApk();
    // this.isMobile = isMobileDevice()
    // console.log("isMobile", this.isMobile);
    this.checkScreenSize();
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    showList() {
      this.isShallow = true;
    },
    hideList() {
      this.isShallow = false;
    },
    showModsDropdown() {
      this.isModsDropdownOpen = true;
    },
    hideModsDropdown() {
      this.isModsDropdownOpen = false;
    },

    mobileHide() {
      console.log(1111111);

      this.isShallow = !this.isShallow;
    },
    // 防止鼠标移入列表时隐藏
    preventHide() {
      clearTimeout(this.hideTimer);
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
      if (!this.isMobile) {
        this.isMobileMenuOpen = false;
      }
    },
    downloadApk() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    goLink(url) {
      window.location.href = url;
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    download() {
      if (typeof this.gotodownload === "function") {
        this.gotodownload();
      } else {
        console.error("gotodownload is not a function");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-tops {
  box-shadow: 0 0 4px #ccc;
  background: #fff;
}

.breadcrumb-bar {
  background: #fff;
  border-top: 1px solid #eee;
  margin-bottom: 16px;
}

.breadcrumb-bar-inner {
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 12px 0 18px;
}

.header-top {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: auto;
  align-items: center;
  // padding: 5px;
  flex-wrap: wrap;

  .navigation-branding {
    display: flex;
    align-items: center;
    gap: 40px;
  }

  .header-right-section {
    display: flex;
    align-items: center;
  }
}

.navigation-title {
  display: flex;
  align-items: center;
  gap: 30px;

  a {
    background: linear-gradient(170deg, #3e713c 0%, #23eeb1 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    border: #000;
  }
}

.link-gb {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-emphasis: none;
}

.header-menu-item {
  color: #000;
  font-size: 20px;
  height: 100%;
  display: flex;
  align-items: center;

  &:hover {
    color: #257973;
  }
}

.ul-pc {
  position: absolute;
  list-style-type: none !important;
  /* 移除项目符号 */
  padding-left: 0;
  /* 移除默认缩进 */
  margin: 0.5rem 0 !important;

  /* 移除默认外边距 */
  li {
    padding: 10px 14px;
    background: #257973;
    color: #fff;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      background: #40cdc4;
    }
  }
}

.downloadBtn {
  padding: 10px 20px;
  border-radius: 8px;
  background-color: #257973;
  border: none;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: #40cdc4;
  }
}

/* 汉堡菜单按钮 */
.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;

  span {
    width: 25px;
    height: 3px;
    background-color: #000;
    margin: 4px 0;
    transition: 0.4s;

    &.open:nth-child(1) {
      transform: rotate(45deg) translate(6px, 9px);
    }

    &.open:nth-child(2) {
      opacity: 0;
    }

    &.open:nth-child(3) {
      transform: rotate(-45deg) translate(6px, -9px);
    }
  }
}

.mobile-menu {
  display: none;
  flex-direction: column;
  gap: 0;
  margin-top: 10px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;

  .mobile-menu-item {
    font-size: 16px;
    padding: 15px 20px;
    border-bottom: 1px solid #f0f0f0;
    color: #333;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #f8f9fa;
      color: #257973;
    }

    &:last-child {
      border-bottom: none;
    }

    &.sub-item {
      padding-left: 35px;
      font-size: 14px;
      color: #666;
      background-color: #fafafa;

      &:hover {
        background-color: #f0f0f0;
        color: #257973;
      }
    }
  }
}


/* PC 菜单 */
.desktop-menu {
  position: relative;
  display: flex;
  gap: 20px;
  cursor: pointer;
  align-items: center;
  margin-right: 40px;

  .dropdown-container {
    top: 100%;
    position: absolute;
    padding-left: 0 !important;
    margin-left: 0 !important;

    .dropdown-item {
      padding: 10px 20px;
      background-color: #257973;
      color: #fff;
      list-style-type: none;
      margin-bottom: 0px !important;
      border-bottom: solid 1px #fff;

      &:hover {
        background-color: #40cdc4;
      }
    }
  }

  .news-item {
    margin-left: 10px;
  }
}



/* 响应式样式 */
@media screen and (max-width: 768px) {
  .breadcrumb-bar-inner {
    width: 100%;
    padding: 10px 16px 12px;
  }

  .header-top {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  }

  .desktop-menu {
    display: none;
  }

  .hamburger {
    display: flex;
  }

  .mobile-menu {
    display: flex;
    width: 100%;
  }

  .navigation-branding {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
    margin: 0 auto;
  }

  .downloadBtn {
    width: 100%;
    margin-top: 10px;
    font-size: 16px;
  }
}
</style>
